import {
  succubus_objective_ObjectivesLib,
  succubus_objective_utils_ObjectiveColumns
 } from "./objectiveslibtypes.d.ts";

const objective = window?.succubus?.objective
const objLib = objective?.ObjectivesLib

export const available = () => objLib !== undefined

if(available()) {
  objLib.init()
}

/** @type {succubus_objective_ObjectivesLib} */
export default objLib?.instance

/** @type {succubus_objective_utils_ObjectiveColumns} */
export const ObjectiveColumns = objective?.utils?.ObjectiveColumns
